// extracted by mini-css-extract-plugin
var _1 = "yfIIORlgqn5wJgdMC9wP";
var _2 = "SMbzlIVeOltBp1kpluXt";
var _3 = "fFd6TrsParqxdvvb_Dc3";
var _4 = "WRyW8tHkUqVgHLvLakl9";
var _5 = "ItUTY1KvTA05DuFPJngW";
var _6 = "UhXcpChP1bYeEVyRFCnP";
export { _1 as "fadeIn", _2 as "modal", _3 as "overlay", _4 as "scaleUp", _5 as "text", _6 as "title" }
